import apiHelper from "../../../services/apiHelper";

const PtCancellationService = {
  getDetails: () => {
    return apiHelper.fetch('/personal-training-cancellation/details')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to get PT cancellation details');
        }
        return response.json();
      });
  },

  submit: () => {
    return apiHelper.fetch('/personal-training-cancellation', { method: 'POST' })
      .then(response => {
        if (!response.ok) {
          return response.json().then(data => Promise.reject(data));
        }
        return response.json();
      });
  }
};

export default PtCancellationService;
